
<div class="main-card mb-3 card">
  <div class="card-body">
    <div class="title-block mb-3">
      <i class="fa fa-fw" [title]="'TR_GOBACK' | translate" (click)="mainService.goBack('templates-info-data')"></i>
      <h5 class="card-title">{{ isCreateForm ? ('TR_CREATE_TEMPLATE_INFO_DATA' | translate) : ('TR_UPDATE_TEMPLATE_INFO_DATA' | translate) }}</h5>
    </div>
    <form (submit)="submitData()" [formGroup]="form">
      <div class="wrap-flex form-outline">
        <div *ngIf="template_view" ngbDropdown>
          <div class="flex flex-column">
            <label>{{ 'TR_TEMPLATEE' | translate }}</label>
            <button type="button" ngbDropdownToggle class="mb-2 mr-2 btn btn-outline-primary">
              {{ selectedTemplateName ? selectedTemplateName : 'TR_TEMPLATEE' | translate }}
            </button>
          </div>
          <div ngbDropdownMenu>
            <button type="button" class="dropdown-item" *ngFor="let item of templates" (click)="setSelectedTemplate(item.id, item.name)">
              {{ item.name }}
            </button>
          </div>
        </div>
        <div ngbDropdown>
          <div class="flex flex-column">
            <label>{{ ('TR_INFO_TYPES' | translate) + mainService.asterisk }}</label>
            <button type="button" ngbDropdownToggle class="mb-2 mr-2 btn btn-outline-primary" [class.error-border]="isInvalidSubmit && !form.value.dtiId">
              {{ form.value.dtiId ? form.value.dtiId : ('TR_INFO_TYPES' | translate) + mainService.asterisk }}
            </button>
          </div>
          <div ngbDropdownMenu>
            <button type="button" class="dropdown-item" *ngFor="let item of templatesInfo" (click)="setSelectedTemplateInfo(item.id, item.position)">
              {{ item.position }}
            </button>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-4 col-md-6">
          <div class="position-relative form-group">
            <label for="data">{{ ('TR_DATA' | translate) + mainService.asterisk }}</label>
            <input
              name="data"
              [placeholder]="('TR_DATA' | translate) + mainService.asterisk"
              type="text"
              class="form-control"
              [class.error-border]="isInvalidSubmit && !form.value.data"
              autocomplete="off"
              formControlName="data"
            />
          </div>
        </div>
      </div>
      <app-submit-button
        [spinnerId]="submitSpinnerId"
        [buttonName]="isCreateForm ? ('TR_CREATE' | translate) : ('TR_UPDATE' | translate)"
        [isInvalidSubmit]="isInvalidSubmit"
        [isFormValid]="form.valid"
      ></app-submit-button>
    </form>
  </div>
</div>